var _path, _polygon, _path2, _polygon2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _polygon3, _circle2, _polygon4, _circle3, _polygon5, _circle4, _path22, _path23;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkills(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 700.74679,
    height: 597.77667,
    viewBox: "0 0 700.74679 597.77667",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M868.01492,746.55858l.0152-.697a80.52864,80.52864,0,0,1,30.11215-60.64309,78.13219,78.13219,0,0,1,16.78623-10.11535l.572-.25474.09758.61813c1.16153,7.3802,3.0009,14.91288,3.85784,18.25612l5.74416-22.41411.63822-.18437a15.27246,15.27246,0,0,1,16.303,5.20879,15.53409,15.53409,0,0,1,1.61173,17.33177c-1.33891,2.49455-2.655,5.09733-3.92819,7.61425-4.37386,8.6493-8.89655,17.59309-15.48708,24.54163a48.6753,48.6753,0,0,1-39.25924,14.64528Z",
    transform: "translate(-249.62661 -151.11166)",
    fill: "#f2f2f2"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "546.768 585.081 536.773 585.08 532.017 546.524 546.77 546.525 546.768 585.081",
    fill: "#ffb6b6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M796.747,746.62045l-30.73878-.00116v-.38874a11.96505,11.96505,0,0,1,11.96439-11.9642h.00074l5.61483-4.2597,10.476,4.26035,2.68329.00009Z",
    transform: "translate(-249.62661 -151.11166)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "650.238 556.92 642.341 563.048 614.944 535.505 626.599 526.46 650.238 556.92",
    fill: "#ffb6b6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M906.53628,716.053l-24.28357,18.84624-.23835-.3071a11.965,11.965,0,0,1,2.11584-16.78725l.00058-.00045,1.82379-6.80774,10.888-3.05769,2.11979-1.64516Z",
    transform: "translate(-249.62661 -151.11166)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M856.62661,521.48485s-.68218,10.43874-1.54259,25.36144c-.14111,2.44744.69106,5.10617.54259,7.76856-.09851,1.76641-1.17624,3.48366-1.27636,5.32545-.10567,1.94378,1.38234,3.66437,1.27636,5.67455-.10355,1.964-1.80109,4.21635-1.90349,6.22674-1.102,21.63419-5.09651,47.53327-1.09651,54.77326,1.97134,3.56812,32,53,32,53s-14,21-18,14c-5.28313-9.24547-46-52.5-46-60.76,0-8.25-9.41993-70.08-9.41993-70.08l-6.56834,36.59036-3.01173,7.24966.94634,4.25606-1.94634,5.74394-.10516,5.68434-1.89484,10.55565s5.69995,82.24,2.49,84.53c-3.22,2.3-18.81006,6.43-20.64991,2.3-1.83007-4.13-8.84008-85.83-8.84008-85.83s-1.91993-37.43994-4-72.24c-.11988-2.02-1.54-4.46-1.65-6.45-.13-2.31.77-5.30994.65-7.55-.13-2.56994-1.27-4.38-1.38-6.84-.85-19.01-.98-33.99.53992-36.27,4.59009-6.88,8.72009-12.38,8.72009-12.38s65.6-16.06,82.12,4.58Z",
    transform: "translate(-249.62661 -151.11166)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M797.62661,324.61485l15.81737-.88448,11.92026,6.50684,33.14757,187.71555s-33.8852,15.66209-54.8852,9.66209-43.1148-5.66209-43.1148-5.66209l16.1148-179.33791,13-12Z",
    transform: "translate(-249.62661 -151.11166)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M824.01455,328.59465l24.483,9.99826a16.66267,16.66267,0,0,1,15.58371,13.66737l-1.6245,48.35257-8.83011,23.002,6.29683,52.40017-3.29683,6.59983,2.84875,6.73651c-4.18164,6.78919-3.33044,15.68512-.84875,25.26349h-3l-6-1S836.417,518.201,833.7107,501.72978c-7.08409-43.11493-11.08409-24.11493-11.08409-24.11493l-3.4872-133.77245Z",
    transform: "translate(-249.62661 -151.11166)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M790.62661,328.61485,767.7557,352.59291A16.66267,16.66267,0,0,0,752.172,366.26028l9.45462,74.35457-4.43717,28.53025,2.43717,6.46975-1.765,7.31259,2.765,6.68741-2,9,3,13,15-4-.1148-10.66209,4-145Z",
    transform: "translate(-249.62661 -151.11166)",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M714.354,451.87174l-31.15473,22.607a6.803,6.803,0,1,0,6.422,9.86626L731.98568,461.729Z",
    transform: "translate(-249.62661 -151.11166)",
    fill: "#ffb6b6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M757.62661,356.61485c-5.92121,2.7311-20.54883,72.65156-24.8419,74.134s-2.65392,1.25967-3.2562,2.49728-.74795,6.7793-4.86925,7.42965-25.896,20.50182-25.896,20.50182l5.51957,18.3993s41.90147-23.93873,53.45495-37.195,17.774-81.42911,17.774-81.42911l1.18175-6.80129S763.54781,353.88375,757.62661,356.61485Z",
    transform: "translate(-249.62661 -151.11166)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M851.58866,442.63989l-27.76457,26.66127a6.803,6.803,0,1,0,7.71282,8.89365l38.86738-28.20563Z",
    transform: "translate(-249.62661 -151.11166)",
    fill: "#ffb6b6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M855.62661,362.61485c-5.49132,3.5164,15.37534,54.52026,11.32578,56.57677s-2.45637,1.61131-2.88345,2.91974.18767,6.81786-3.8057,8.02658-22.84379,23.85561-22.84379,23.85561l7.98773,17.46986s38.22762-29.45241,47.85648-44.16628,3.363-19.68228,3.363-19.68228c-11.94605-25.37237-23.11939-66.75079-40-64C856.62661,343.61485,861.11792,359.09846,855.62661,362.61485Z",
    transform: "translate(-249.62661 -151.11166)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 551.39233,
    cy: 142.73745,
    r: 26.80653,
    fill: "#ffb6b6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M828.16428,311.12189s-5.904,1.61882-9.33976,2.52007c.17761-2.55664,1.28486-4.95,1.84714-7.45109s.44025-5.44257-1.41851-7.20853-5.73-1.07792-6.02951,1.46313q-2.35871-5.04375-4.72718-10.1059c-4.50223,9.26712-13.70672,1.36989-23.74286,3.71145-5.11992,1.20608-11.53673.688-14.24163-3.82337a16.71144,16.71144,0,0,0,3.782-4.53721,15.26826,15.26826,0,0,1-4.8081.60916,10.07877,10.07877,0,0,1,4.45653-8.1348c1.44345-.94375-2.12937-4.30177-.86958-5.48383,2.58379-2.41255,4.31775-.77428,5.8442-3.95434a11.74567,11.74567,0,0,1,10.61238-6.48825c4.38693.10274,12.24765.0604,13.94968,4.102,5.42448-3.551,12.9755-2.5477,18.27776,1.17736,4.40717,3.08424,9.42281,12.40684,10.52973,17.6696C833.39351,290.45,830.95413,306.53528,828.16428,311.12189Z",
    transform: "translate(-249.62661 -151.11166)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M496.12661,252.11485H324.47817A12.21074,12.21074,0,0,1,312.154,240.93419a12.00675,12.00675,0,0,1,11.97266-12.81934h172a12,12,0,0,1,0,24Z",
    transform: "translate(-249.62661 -151.11166)",
    fill: "#6c63ff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M594.86293,271.61485H312.62661a1,1,0,0,1,0-2H594.86293a1,1,0,0,1,0,2Z",
    transform: "translate(-249.62661 -151.11166)",
    fill: "#e6e6e6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M583.12661,252.61485h-259a12.5,12.5,0,0,1,0-25h259a12.5,12.5,0,0,1,0,25Zm-259-23a10.5,10.5,0,0,0,0,21h259a10.5,10.5,0,0,0,0-21Z",
    transform: "translate(-249.62661 -151.11166)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M419.12661,346.11485H324.47817A12.21074,12.21074,0,0,1,312.154,334.93419a12.00675,12.00675,0,0,1,11.97266-12.81934h95a12,12,0,0,1,0,24Z",
    transform: "translate(-249.62661 -151.11166)",
    fill: "#6c63ff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M594.86293,365.61485H312.62661a1,1,0,0,1,0-2H594.86293a1,1,0,0,1,0,2Z",
    transform: "translate(-249.62661 -151.11166)",
    fill: "#e6e6e6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M583.12661,346.61485h-259a12.5,12.5,0,0,1,0-25h259a12.5,12.5,0,0,1,0,25Zm-259-23a10.5,10.5,0,0,0,0,21h259a10.5,10.5,0,0,0,0-21Z",
    transform: "translate(-249.62661 -151.11166)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M546.12661,440.11485H324.47817A12.21074,12.21074,0,0,1,312.154,428.93419a12.00675,12.00675,0,0,1,11.97266-12.81934h222a12,12,0,0,1,0,24Z",
    transform: "translate(-249.62661 -151.11166)",
    fill: "#6c63ff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M594.86293,459.61485H312.62661a1,1,0,0,1,0-2H594.86293a1,1,0,0,1,0,2Z",
    transform: "translate(-249.62661 -151.11166)",
    fill: "#e6e6e6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M583.12661,440.61485h-259a12.5,12.5,0,0,1,0-25h259a12.5,12.5,0,0,1,0,25Zm-259-23a10.5,10.5,0,0,0,0,21h259a10.5,10.5,0,0,0,0-21Z",
    transform: "translate(-249.62661 -151.11166)",
    fill: "#3f3d56"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "230.214 88.806 228.214 88.806 228.214 11.763 372.871 11.763 372.871 13.763 230.214 13.763 230.214 88.806",
    fill: "#ccc"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 379.0541,
    cy: 11.9459,
    r: 11.9459,
    fill: "#ccc"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "160.786 182.806 162.786 182.806 162.786 138.763 18.129 138.763 18.129 140.763 160.786 140.763 160.786 182.806",
    fill: "#ccc"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9459,
    cy: 138.9459,
    r: 11.9459,
    fill: "#ccc"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "296.214 280.201 294.214 280.201 294.214 335.244 416.871 335.244 416.871 333.244 296.214 333.244 296.214 280.201",
    fill: "#ccc"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 423.0541,
    cy: 335.06048,
    r: 11.9459,
    fill: "#ccc"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M949.18271,748.581l-271.75.30734a1.19069,1.19069,0,1,1,0-2.38137l271.75-.30733a1.19068,1.19068,0,0,1,0,2.38136Z",
    transform: "translate(-249.62661 -151.11166)",
    fill: "#cacaca"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M839.70638,328.61772a4.459,4.459,0,0,0-6.04285-1.43262c1.47-2.04278.36243-5.53375-1.94165-6.94482-2.61035-1.59876-5.908-1.33392-8.95251-1.016L797.81246,321.831c-2.8775.30053-5.83478.62445-8.3963,1.96954s-4.6687,3.97016-4.52069,6.85962a14.35827,14.35827,0,0,0-6.12183-.83026c-2.05145.3233-4.07452,1.82269-4.2934,3.88794-.35125,3.31409,3.5857,5.228,6.79212,6.13653q8.93041,2.53033,17.86084,5.0608l-1.8357.39233a76.07616,76.07616,0,0,0,34.45551-4.98456c2.50818-.98889,5.04779-2.17328,6.804-4.21893S841.07973,330.93785,839.70638,328.61772Z",
    transform: "translate(-249.62661 -151.11166)",
    fill: "#e6e6e6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkills);
export default __webpack_public_path__ + "static/media/skills.31175bb32c2cd6fbc9e80d65d400acaa.svg";
export { ForwardRef as ReactComponent };